import { getOccTransport } from "~/common/api/occTransport";

interface LmbtConfiguratorUrlResponse {
  url: string;
}

function isLmbtConfiguratorUrlResponse(value: unknown): value is LmbtConfiguratorUrlResponse {
  if (typeof value !== "object" || value === null || !("url" in value)) {
    return false;
  }
  return typeof value.url === "string" && value.url.trim().length > 0;
}

export async function fetchLmbtConfiguratorUrl(code: string, signal?: AbortSignal): Promise<string> {
  const { request, url } = getOccTransport();
  const response = await request(url(`/lmbt-configurator/${encodeURIComponent(code)}`), { signal });
  if (!response.ok) {
    const error = new Error(`Failed to resolve LMBT configurator URL: ${response.status}`);
    (error as Error & { status: number }).status = response.status;
    throw error;
  }

  const payload: unknown = await response.json();
  if (!isLmbtConfiguratorUrlResponse(payload)) {
    throw new Error("Invalid LMBT configurator URL response");
  }
  return payload.url;
}
